var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pt-2 pb-4 mt-3" },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", color: "white" } },
        [_c("v-toolbar-title", [_vm._v("Invitations")])],
        1
      ),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.smAndDown
        ? _vm._l(_vm.invitations, function(invitation) {
            return _c(
              "v-card",
              { key: invitation.id, staticClass: "xs12 my-2" },
              [
                _c(
                  "v-card-title",
                  [
                    _c("v-layout", { attrs: { column: "" } }, [
                      _c("h6", { staticClass: "title text-truncate" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(invitation.email) +
                            "\n        "
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-card-text",
                  [
                    _c("b", [_vm._v("Permissions:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          invitation.companyPermissions
                            ? invitation.companyPermissions.join(", ")
                            : null
                        )
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Created: ")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatDate")(invitation.created)) +
                        " "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Expiration: ")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatDate")(invitation.expiration)) +
                        " "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Invited By: ")]),
                    _vm._v(" " + _vm._s(invitation.invitedBy)),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Status: ")]),
                    _vm._v(" "),
                    invitation.user
                      ? _c(
                          "v-chip",
                          {
                            staticClass: "text-truncate",
                            attrs: { color: "success", "text-color": "white" }
                          },
                          [
                            invitation.user.name
                              ? _c("span", [
                                  _vm._v(
                                    "Accepted by " +
                                      _vm._s(invitation.user.name)
                                  )
                                ])
                              : _c("span", [_vm._v("Accepted")])
                          ]
                        )
                      : _vm.hasExpired(invitation)
                      ? _c(
                          "v-chip",
                          { attrs: { color: "accent", "text-color": "white" } },
                          [_vm._v("\n          Expired\n        ")]
                        )
                      : _c(
                          "v-chip",
                          {
                            attrs: { color: "primary", "text-color": "white" }
                          },
                          [_vm._v("\n          Active\n        ")]
                        ),
                    _vm._v(" "),
                    _c("br")
                  ],
                  1
                )
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.smAndUp
        ? _c("v-data-table", {
            attrs: {
              headers: _vm.invitationsHeaders,
              pagination: _vm.pagination,
              "disable-initial-sort": "",
              items: _vm.invitations
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "items",
                  fn: function(slotItems) {
                    return [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n          " +
                              _vm._s(slotItems.item.email) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                slotItems.item.companyPermissions
                                  ? slotItems.item.companyPermissions.join(", ")
                                  : ""
                              ) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("formatDate")(slotItems.item.created)
                              ) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("formatDate")(slotItems.item.expiration)
                              ) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n          " +
                              _vm._s(slotItems.item.invitedBy) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            slotItems.item.user
                              ? _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "success",
                                      "text-color": "white"
                                    }
                                  },
                                  [
                                    slotItems.item.user.name
                                      ? _c("span", [
                                          _vm._v(
                                            "Accepted by " +
                                              _vm._s(slotItems.item.user.name)
                                          )
                                        ])
                                      : _c("span", [_vm._v("Accepted")])
                                  ]
                                )
                              : _vm.hasExpired(slotItems.item)
                              ? _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "accent",
                                      "text-color": "white"
                                    }
                                  },
                                  [_vm._v("\n            Expired\n          ")]
                                )
                              : _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "primary",
                                      "text-color": "white"
                                    }
                                  },
                                  [_vm._v("\n            Active\n          ")]
                                )
                          ],
                          1
                        )
                      ])
                    ]
                  }
                }
              ],
              null,
              false,
              2783012208
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc2a638", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc2a638","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/InvitationsSection.vue
// module id = null
// module chunks = 